import { render } from "./RegisterStep1.vue?vue&type=template&id=83381364&scoped=true&lang=pug"
import script from "./RegisterStep1.vue?vue&type=script&lang=js"
export * from "./RegisterStep1.vue?vue&type=script&lang=js"

import "./RegisterStep1.vue?vue&type=style&index=0&id=83381364&scoped=true&lang=scss"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83381364"]])

export default __exports__